import React from 'react';
import 'twin.macro';
import { useSequencesTrash } from '@teetsh/app/src/containers/UserSettings/Trash/Sequences/useSequencesTrash';
import { useRestoreSequence } from '@teetsh/app/src/containers/UserSettings/Trash/Sequences/useRestoreSequence';
import { RestorableList } from '@teetsh/app/src/containers/UserSettings/Trash/components/RestorableList';
import { RestorableSequence } from '@teetsh/app/src/types/sequences';
import { useTranslation } from 'react-i18next';

function Details({ cycle, nbOfFdp }: RestorableSequence) {
  const { t } = useTranslation(['userSettings']);

  return (
    <div tw="font-light">
      <div>{t('userSettings:restore.list.nbOfFdp', { count: nbOfFdp })}</div>
      {cycle && <div>{cycle}</div>}
    </div>
  );
}

export function SequencesRestorableList() {
  const { data = [] } = useSequencesTrash();
  const restore = useRestoreSequence();

  return (
    <RestorableList<RestorableSequence>
      items={data}
      restore={restore}
      cardFileDetails={Details}
      tableFileDetails={({ row }) => Details(row.original)}
    />
  );
}
